<template>
  <div id="top-cart">
    <div @click="vOpenCart" class="top-cart-menu">
      <div class="cart-img">
        <img src="../assets/img/cart.png" alt="Mon panier" />
        <span class="cart-items">{{items_number}}</span>
      </div>
      <div class="cart-libelle hide-xs show-md">
        <span>{{$_('my_cart')}}</span>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="show_cart" id="cart-list">
        <div class="cart-item">
          <div class="cart-close" @click="vOpenCart">
            <img src="../assets/img/cart-close.png" />
          </div>
          <ul v-if="getCart.length > 0">
            <li v-for="(item, index) in getCart" :key="index">
              <span class="item-name">{{item.OMOD}}</span>
              <span class="item-quantity">x{{item.OQTE}}</span>
              <span class="item-price">{{item.OMTHT}} {{pcdev}}</span>
            </li>
          </ul>
          <ul v-else>
            <li>{{$_('no_items_in_cart')}}</li>
          </ul>
        </div>
        <div class="cart-total">
          <span>
            <strong>{{$_('total').toUpperCase()}}</strong> ({{$_('including_delivery')}})
          </span>
          <span class="cart-total-price">{{pmtttc}} {{pcdev}}</span>
        </div>
        <div class="btn-view-cart">
          <span @click="goToCart()" class="btn">{{$_('view_my_cart').toUpperCase()}}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import cartService from '@/modules/panier/services/cartService';

export default {
  data() {
    return {
      pcdev: '',
      pmtttc: 0,
      items_number: 0,
      show_cart: false
    };
  },
  created() {
    this.getCurrentCart();
  },
  methods: {
    vOpenCart() {
      this.show_cart = !this.show_cart;
    },
    goToCart() {
      this.$router.push({name: 'cart'});
      this.vOpenCart();
    },
    getCurrentCart() {
      cartService.getCurrentCart()
      .then(res => {
        if(res.data !== undefined) {
          this.$store.dispatch('panier/SET',[
            {key: 'pnbon', value: res.data.PNBON_OUT},
            {key: 'pcpromo', value: res.data.PCPROMO},
            {key: 'pcdev', value: res.data.PCDEV},
            {key: 'pmtht', value: res.data.PMTHT},
            {key: 'pmtttc', value: res.data.PMTTTC},
            {key: 'pmttrsp', value: res.data.PMTTRSP}]
          )

          if(res.data.DS_O !== undefined) {
            this.$store.dispatch('panier/SET', {key: 'cart', value: res.data.DS_O.OUT2});
          }

          this.pcdev = res.data.PCDEV;
          this.pmtttc = res.data.PMTTTC;
          this.items_number = this.$store.getters['panier/get_cart'].length;

          this.$store.dispatch('panier/SET', {key: 'reload_cart', value: false});
        }
      }).catch(err => {
        console.error(err);
      })
    }
  },
  computed: {
    getCart() {
      return this.$store.getters['panier/get_cart'];
    },
    getTncli() {
      return this.$store.getters['application/get_application_customer'];
    },
    getReloadCart() {
      return this.$store.getters['panier/get_reload_cart'];
    }
  },
  watch: {
    getReloadCart(val) {
      if (val) {
        this.getCurrentCart();
      }
    },
    getTncli() {
      if(localStorage.getItem('satabapp-user') !== null) {
        this.getCurrentCart();
      }
    }
  }
};
</script>

<style scoped>
#top-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: solid 1px #e9e9e9;
  border-right: solid 1px #e9e9e9;
  width: 300px;
  height: 100%;
  min-height: 75px;
  position: relative;
}
.top-cart-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  height: 75px;
}
#top-cart .top-cart-menu:hover {
  cursor: pointer;
}
#top-cart .cart-img {
  width: 20px;
  margin-right: 15px;
  position: relative;
}
#top-cart .cart-libelle span {
  font-size: var(--fz-md);
}
#top-cart .cart-img .cart-items {
  position: absolute;
  width: 15px;
  height: 15px;
  background: #f00b35;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  top: 10px;
  right: -7px;
  color: #fff;
}
#cart-list {
  padding: 25px 30px;
  position: absolute;
  top: 90px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: #fff;
  z-index: 10001;
  width: 300px;
  right: 15px;
}
#cart-list::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  top: -10px;
  right: 0;
  left: 0;
  margin: auto;
}
#cart-list .item-name {
  color: #8b8b8b;
  font-size: var(--fz-sm);
  width: 50%;
  display: inline-block;
}
#cart-list .item-quantity {
  font-size: var(--fz-sm);
  width: 10%;
  display: inline-block;
}
#cart-list .item-price {
  font-size: var(--fz-sm);
  width: 40%;
  display: inline-block;
  text-align: right;
}
#cart-list ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: scroll;
}
#cart-list ul li {
  list-style-type: none;
  width: 100%;
}
.cart-close {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 15px;
  position: relative;
}
.cart-close:hover {
  cursor: pointer;
}
.cart-close img {
  width: 10px;
}
.cart-total {
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}
.cart-total span {
  font-size: var(--fz-sm);
}

.cart-total > span {
  width: 50%;
  display: inline-block;
}
.cart-total-price {
  color: #f00b35;
  display: inline-block;
  width: 50%;
  text-align: right;
}
.btn-view-cart span {
  text-decoration: none;
  display: block;
  margin: auto;
  background: #000;
  color: #fff;
  text-align: center;
  padding: 10px 20px;
  font-size: var(--fz-md);
  width: 100%;
}
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
.cart-opacity {
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
}

@media (min-width: 340px) {
  #top-cart {
    padding: 0px;
    width: 85px;
  }
  #top-cart .cart-img {
    margin-right: 0px;
  }
  #top-cart .cart-img {
    min-width: 29px;
  }
}

@media (min-width: 768px) {
  #top-cart {
    padding: 0px 60px;
    width: 300px;
  }
  #top-cart .cart-img {
    margin-right: 10px;
    min-width: 20px;
  }
}

@media (min-width: 768px) {
  #top-cart {
    padding: 0px 60px;
    width: auto;
    flex: 1;
  }
}


</style>